import React, {useState, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {ExplainerSection} from './sections/ExplainerSection';
import {PrerequisitesSection} from './sections/PrerequisitesSection';
import {SetupGuidesSection} from './sections/SetupGuidesSection';
import {OfficialPromptsSection} from './sections/OfficialPromptsSection';
import {PlaygroundSection} from './sections/PlaygroundSection';
import {FaIcon} from '../FaIcon';
import {LocalStorage} from '../../utils/LocalStorage';
import {usePreviewContext} from '../../context/PreviewContext';
import {APIClient} from '../../utils/APIClient';
import {API_URL} from '../../settings/local_settings';

export function DashboMCPContent() {
    const {t} = useTranslation();
    const {isPreview, previewClientId} = usePreviewContext();
    const [promptText, setPromptText] = useState(null);

    useEffect(() => {
        const url = `${API_URL}agent/prompts/official/[Dashbo] Analista senior (Agency)/`;
        new APIClient(url).call('GET').then(response => {
            if (response && response.prompt) {
                setPromptText(response.prompt.prompt_text);
            }
        });
    }, []);

    let autoClientId = null;
    if (isPreview && previewClientId) {
        autoClientId = previewClientId;
    } else if (LocalStorage.isClientUser()) {
        autoClientId = LocalStorage.fetchUserClientId();
    }

    return (
        <div className="dashbo-mcp-page">
            <header className="dashbo-mcp-hero">
                <div className="dashbo-mcp-hero-content">
                    <div className="dashbo-mcp-hero-icon">
                        <FaIcon iconName="bolt"/>
                    </div>
                    <div className="dashbo-mcp-hero-text">
                        <h1>{t('dashbo_mcp.hero_title')}</h1>
                        <p>{t('dashbo_mcp.hero_subtitle')}</p>
                    </div>
                </div>
            </header>

            <div className="section-body">
                <ExplainerSection/>
                <PrerequisitesSection/>
                <SetupGuidesSection promptText={promptText}/>
                <PlaygroundSection autoClientId={autoClientId}/>
                <OfficialPromptsSection promptText={promptText}/>
            </div>
        </div>
    );
}
